import React from "react";
import AppHeader from "./AppHeader";

export default function IntranetHeader(props) {
  return <AppHeader variant="staff" {...props} />;
}
